module.exports = "data:text/x-markdown;base64,Q29uZ3JhdHMgISEhIQoKTmF0aW9uYWwgWWFuZyBNaW5nIENoaWFvIFR1bmcgVW5pdmVyc2l0eSB3aWxsIGJlIHRoZSBiZXN0IFVuaXZlcnNpdHkgaW4gVGFpd2FuICEhCgpMb29raW5nIGZvcndhcmQgdG8gbWVldGluZyB5b3UgYXQgQ3Jvc3NsaW5rIDIwMTkh"


//////////////////
// WEBPACK FOOTER
// ./gamedata/descriptions/levels/university_complete.md
// module id = 1412
// module chunks = 0